<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import { updateTheme } from '@ant-design-vue/pro-layout'
import defaultSettings from '@/config/defaultSettings'
export default {
  name: 'BlankLayout',
  created() {
    if (process.env.NODE_ENV !== 'production' || process.env.VUE_APP_PREVIEW === 'true') {
      updateTheme(defaultSettings.primaryColor)
    }
  }
}
</script>

<style rel="stylesheet/less" lang="less">
@import "./BasicLayout.less";
</style>
